import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../../components/BreadCrumbs/BreadCrumbs';
import Page from '../../../../components/Page/Page';
import { SETTINGS } from '../../../../routes/routeConstants';
import ProfilePictureArea from './ProfilePictureArea';
import WorkHistory from './WorkHistory';

const ProfileSettings = () => {
  const { pathname } = useLocation();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Settings`,
        link: `/${SETTINGS}`,
      },
      {
        name: `Profile Settings`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Profile Settings'>
      <Container>
        <BreadCrumbs pathData={pathArr as any} hideOnWeb />{' '}
        <ProfilePictureArea />
        <WorkHistory />
      </Container>
    </Page>
  );
};

export default ProfileSettings;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
